import { render, staticRenderFns } from "./ConsultationsOverview.vue?vue&type=template&id=47d0b9dd&scoped=true&"
import script from "./ConsultationsOverview.vue?vue&type=script&lang=js&"
export * from "./ConsultationsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d0b9dd",
  null
  
)

export default component.exports